/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternetRegistrationMatchResponse } from './InternetRegistrationMatchResponse';
import {
    InternetRegistrationMatchResponseFromJSON,
    InternetRegistrationMatchResponseFromJSONTyped,
    InternetRegistrationMatchResponseToJSON,
    InternetRegistrationMatchResponseToJSONTyped,
} from './InternetRegistrationMatchResponse';
import type { InternetRegistrationPartyResponse } from './InternetRegistrationPartyResponse';
import {
    InternetRegistrationPartyResponseFromJSON,
    InternetRegistrationPartyResponseFromJSONTyped,
    InternetRegistrationPartyResponseToJSON,
    InternetRegistrationPartyResponseToJSONTyped,
} from './InternetRegistrationPartyResponse';

/**
 * 
 * @export
 * @interface InternetRegistrationReviewResponse
 */
export interface InternetRegistrationReviewResponse {
    /**
     * 
     * @type {Date}
     * @memberof InternetRegistrationReviewResponse
     */
    submittedUtc: Date;
    /**
     * 
     * @type {InternetRegistrationPartyResponse}
     * @memberof InternetRegistrationReviewResponse
     */
    newRegistration: InternetRegistrationPartyResponse;
    /**
     * 
     * @type {InternetRegistrationPartyResponse}
     * @memberof InternetRegistrationReviewResponse
     */
    duplicateCandidate: InternetRegistrationPartyResponse | null;
    /**
     * 
     * @type {InternetRegistrationMatchResponse}
     * @memberof InternetRegistrationReviewResponse
     */
    matchingFields: InternetRegistrationMatchResponse | null;
}

/**
 * Check if a given object implements the InternetRegistrationReviewResponse interface.
 */
export function instanceOfInternetRegistrationReviewResponse(value: object): value is InternetRegistrationReviewResponse {
    if (!('submittedUtc' in value) || value['submittedUtc'] === undefined) return false;
    if (!('newRegistration' in value) || value['newRegistration'] === undefined) return false;
    if (!('duplicateCandidate' in value) || value['duplicateCandidate'] === undefined) return false;
    if (!('matchingFields' in value) || value['matchingFields'] === undefined) return false;
    return true;
}

export function InternetRegistrationReviewResponseFromJSON(json: any): InternetRegistrationReviewResponse {
    return InternetRegistrationReviewResponseFromJSONTyped(json, false);
}

export function InternetRegistrationReviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternetRegistrationReviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'submittedUtc': (new Date(json['submittedUtc'])),
        'newRegistration': InternetRegistrationPartyResponseFromJSON(json['newRegistration']),
        'duplicateCandidate': InternetRegistrationPartyResponseFromJSON(json['duplicateCandidate']),
        'matchingFields': InternetRegistrationMatchResponseFromJSON(json['matchingFields']),
    };
}

export function InternetRegistrationReviewResponseToJSON(json: any): InternetRegistrationReviewResponse {
    return InternetRegistrationReviewResponseToJSONTyped(json, false);
}

export function InternetRegistrationReviewResponseToJSONTyped(value?: InternetRegistrationReviewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submittedUtc': value['submittedUtc'].toISOString(),
        'newRegistration': InternetRegistrationPartyResponseToJSON(value['newRegistration']),
        'duplicateCandidate': InternetRegistrationPartyResponseToJSON(value['duplicateCandidate']),
        'matchingFields': InternetRegistrationMatchResponseToJSON(value['matchingFields']),
    };
}

